
import { cn } from "./index";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-rounding-sm bg-accent", className)}
      {...props}
    />
  );
}

export { Skeleton };
